export default "__VITE_ASSET__bYx6iYoB__"